const items=[
    {
    id:0,
    item_name:'Hybrid Rose',
    item_price:100,
    image:'/images/rose1.jpg',
    item_stock:0,
    info:'Hybrid tea roses, the products of a cross between hybrid perpetual roses and old-fashioned tea roses, are rose royalty. They are the most popular roses in the world and perhaps the most popular flowers. Hybrid teas have all the virtues you look for in a flower: beauty, fragrance, and easy care.'

    }
    ,
    {
        id:1,
        item_name:'Polyantha',
        item_price:19,
        image:'/images/rose2.jpg',
        item_stock:8,
        info:'Polyantha roses are compact, dwarf shrubs with closely packed bunches of small usually semi-double or double flowers in colours including white, cream, peach, shades of pink or red. Sprays will flower throughout the summer and these roses grow from 30-90cm (2-3ft) high.'
        
    }
    ,
    {
        id:2,
        item_name:'Floribunda',
        item_price:99,
        image:'/images/rose3.jpg',
        item_stock:1,
        info:'Produced by crossing hybrid tea roses and polyantha roses, floribundas are typically smaller and bushier than hybrid tea roses, and more upright than polyanthas. If youre seeking roses for fragrance, take a look at our pick of the top roses to grow for scent. More on growing roses: Guide to growing roses in pots.'
    }
    ,
    {
        id:3,
        item_name:'Patio',
        item_price:180,
        image:'/images/rose4.jpg',
        item_stock:10,
        info:'A patio rose is a miniature floribunda rose that can come in a variety of styles. ... Patio roses do not require too much maintenance and are smaller than the average rose (the clue is in the name!). These types of roses are actually good for slope and erosion control.'
    }
    ,
    {
        id:4,
        item_name:'Ground cover',
        item_price:190,
        image:'/images/rose5.jpg',
        item_stock:0,
        info:'Contrary to popular belief, Lorem Ipsum is not simply random text.popular belief, Lorem Ipsum is not simply random text.popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC'
    }
    ,
    {
        id:5,
        item_name:'Climbing',
        item_price:200,
        image:'/images/rose6.jpg',
        item_stock:1,
        info:'Climbing roses for north-facing or shady walls · English Shrub roses make good climbers and will flower on a north-facing wall, pillar or arch. '

    }
    ,
    {
        id:6,
        item_name:'Rambling',
        item_price:210,
        image:'/images/rose7.jpg',
        item_stock:1,
        info:'the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and consectetur, from a Lorem Ipsum passage, and consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical'
    }
    ,
    {
        id:7,
        item_name:'Damask',
        item_price:10,
        image:'/images/rose8.jpg',
        item_stock:10,
        info:'Rosa × damascena, more commonly known as the Damask rose, or sometimes as the rose of Castile, is a rose hybrid, derived from Rosa gallica and Rosa moschata. Further DNA analysis has shown that a third species, Rosa fedtschenkoana, is associated with the Damask rose'
    }
    ,
    {
        id:8,
        item_name:'Gallica',
        item_price:10,
        image:'/images/rose9.jpg',
        item_stock:10,
        info:'et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem'
    }
    ,
    {
        id:9,
        item_name:'gift Roses',
        item_price:10,
        image:'/images/rose10.jpg',
        item_stock:10,
        info:'he standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and'
    }
    ,
    {
        id:10,
        item_name:'Centifolia',
        item_price:10,
        image:'/images/rose11.jpg',
        item_stock:10,
        info:'1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.'
    }
    ,
    {
        id:11,
        item_name:'Rosa canina',
        item_price:10,
        image:'/images/rose12.jpg',
        item_stock:10,
        info:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected'
    }
];
export default items;